module.exports = __webpack_public_path__ + "static/media/attachmenticon.8358210a.svg";